import * as React from 'react';

import config from '../../config';
import { useSelector, useDispatch } from 'react-redux';
import { navigateTop } from '../routing/router-utils';
import { setIsPickup } from '../actions/cartActions';
import Burger from 'react-css-burger';
import MenuItems from '../hamburgerMenu/MenuItems';
import WideScreenOnly from '../mediaQuery/WideScreenOnly';
import SlideInCart from '../checkout/SlideInCart';
import OrderTypeButtons from './OrderTypeButtons';
import ServiceAddress from './ServiceAddress';
import ErrorBoundary from './ErrorBoundary';

import zipRunLogo from '../../assets/ZipRunLogoTransSm.png';

import styles from './PageHeader.module.css';

const PageHeader = () => {

  // Related to additional sticky header styling 
  const navRef = React.useRef(null);
  
  const isPickup = useSelector(state => state.is_pickup);
  const dispatch = useDispatch();

  // Hamburger menu state
  const [menuOpen, setMenuOpen] = React.useState(false);

  React.useEffect(() => {
    // Add scroll handler 
    const scrollingStyle = styles.pageHeaderScrolled;
    const handleScroll = () => {
      if (navRef.current) {
        window.scrollY > 0
        ? navRef.current.classList.add(scrollingStyle)
        : navRef.current.classList.remove(scrollingStyle);
      }
    };
    // passive for best UX
    document.addEventListener('scroll', handleScroll, {passive: true});
    
    // Remove scroll handler on unmount
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };  
  }, []); 
  
  return (
      <> 
        <ErrorBoundary>
          <div id="header" ref={navRef} className={styles.pageHeader}>
            <div className={styles.burgerWrap}>
              <div id="burgerIcon">
                <Burger 
                  active={menuOpen}
                  burger='spring' 
                  onClick={() => setMenuOpen(!menuOpen)} 
                  hoverOpacity={0.8}
                  scale={.6}
                  style={{margin: '8px 2px', position:'relative', 'zIndex': 3, boxShadow:'none'}}
                />
              </div>
              <MenuItems open={menuOpen} setOpen={setMenuOpen} /> 
            </div>
        
            <div className={styles.logoArea}>
              {/* logo is positioned absolutely to be centered, the wrapper div just clears some space */}
              <div className={styles.logoWrap}>
                <div className={styles.logoBackground}>
                  <img alt="logo" onClick={() => navigateTop('/')} className={styles.zipRunLogo} src={zipRunLogo} />
                </div>
              </div>
            </div>
      
            { !config.IS_PREVIEW_MODE &&
              <>
              <OrderTypeButtons inNav isPickup={isPickup} handlePickupClick={(isPickup) => dispatch(setIsPickup(isPickup))} />
              <ServiceAddress isPickup={isPickup} />
              </>
            }
        
            <div className={styles.cartWrap}>
              <WideScreenOnly wideEnabled={false}>
                <SlideInCart />
              </WideScreenOnly>
              <WideScreenOnly wideEnabled={true}>
                <SlideInCart isWideScreen /> 
              </WideScreenOnly>
            </div>
          </div>
          { !config.IS_PREVIEW_MODE &&
            <div className={styles.deliveryAddressBar}>
              <ServiceAddress inAddressBar isPickup={isPickup} />
            </div>
          }
        </ErrorBoundary>
    </>
  );  
}

export default PageHeader;
